import { render, staticRenderFns } from "./AlBreadcrumb.vue?vue&type=template&id=70e4aaa4&"
import script from "./AlBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./AlBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./AlBreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports